import { ResolvedFleetEntry } from "../../api/fleet"
import { sanitiseReg } from "../utils"

const getEntryHashKey = (entry: ResolvedFleetEntry) =>
  [
    sanitiseReg(entry.registrationNumber),
    entry.vehicleId,
    entry.make,
    entry.model,
    entry.onCoverDate,
    entry.offCoverDate,
  ].join(`|`)

export const getChangedEntries = (
  initalEntries: ReadonlyArray<ResolvedFleetEntry>,
  currentEntries: ReadonlyArray<ResolvedFleetEntry>
) => {
  const hashes = new Set(initalEntries.map(getEntryHashKey))
  const test = currentEntries.filter((v) => !hashes.has(getEntryHashKey(v)))

  return test
}

export const getUnchangedEntries = (
  changedEntries: ReadonlyArray<ResolvedFleetEntry>,
  currentEntries: ReadonlyArray<ResolvedFleetEntry>,
  expectedChangeVrns?: string[]
) => {
  if (!expectedChangeVrns?.length) return []
  const changedEntriesVrns = new Set(changedEntries.map((v) => sanitiseReg(v.registrationNumber)))
  const entryByVrn = Object.fromEntries(currentEntries.map((v) => [sanitiseReg(v.registrationNumber), v]))

  return expectedChangeVrns
    .map(sanitiseReg)
    .filter((vrn) => !changedEntriesVrns.has(vrn) && entryByVrn[vrn])
    .map((vrn) => entryByVrn[vrn])
}
